import { combineReducers } from 'redux';

import app from './reducers/appReducer';
import subscription from './reducers/subscriptionReducer';
import soundCloud from './reducers/soundCloudReducer';
import device from './reducers/deviceReducer';
import user from './reducers/userReducer';
import featuredPlaylist from './reducers/featuredPlaylistReducer';
import userPlaylists from './reducers/userPlaylistsReducer';
import activePlaylist from './reducers/activePlaylistReducer';
import artwork from './reducers/artworkReducer';
import mobileQueue from './reducers/mobileReducer';
import homePlaylist from './reducers/homePlaylistReducer';
import myPlaylist from './reducers/myPlaylistReducer';
import setting from './reducers/settingReducer';

const rootReducer = combineReducers({
  app,
  user,
  soundCloud,
  subscription,
  device,
  featuredPlaylist,
  userPlaylists,
  activePlaylist,
  artwork,
  mobileQueue,
  homePlaylist,
  myPlaylist,
  setting,
});

export default rootReducer;
